<div class="loading-container">
  <ng-lottie [options]="lottieConfig"> </ng-lottie>
</div>
